import React from 'react';
import classNames from 'classnames';
import { LegendIcon } from '../utils/callout-legend-icon';
import { DeviceCardProps } from '../utils/types';

export const renderCustomCallout = (data: any, styles: any, dateRange: DeviceCardProps['dateRange'], i18n: DeviceCardProps['i18n']) => {
  if (!data) {
    return null;
  }

  const {
    legend, legendColor, metricValue, total, displayName,
  } = data;

  return (
    <div className={classNames(styles.customCallout, 'ba-device-default-callout')}>
      <div className={classNames(styles.legend, 'ba-device-default-callout-title')}>{i18n.getString(legend)}</div>
      <div className={classNames(styles.metric, 'ba-device-default-callout-metric')}>{displayName}</div>
      <div className={classNames(styles.legendIcon, 'ba-device-default-callout-legend-icon')}>
        <LegendIcon color={legendColor} />
        <span className={classNames(styles.date, 'ba-device-default-callout-date-range')}>
          {dateRange.RangeStartDate} - {dateRange.RangeEndDate}
        </span>
      </div>
      <div className={classNames('ba-device-default-metric-value')}><b>{metricValue} ({total}{i18n.getString(_TL_('% of total'))})</b></div>
    </div>
  );
};
